import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Checkbox, Confirm, Form, Grid, Input, Modal, Panel, Tabs, InfoTooltip,
} from 'framework-ui-components';

import { preferenzeStampa, soscaf } from 'apis/setteTrentaApi';
import AssistenteButton from '../../../components/Assistente';


const FORM_INITIAL_STATE = {

  Gruppo730: false,
  StampaDichiarazione: true,
  PromemoriaConguagli: false,
  DelegaPrecompilatoCU: true, // DelegaPrecompilatoCU AnnoImpostaPiuUno
  StampaF24: false,
  RichiestaAccredito: false,
  CalcoloBonusIRPEF: false,
  Fatture: false,

  GruppoAutocertificazioni: false,
  AutocertificazioneFamiliari: false,
  AutocertificazioneC4: false,
  AutocertificazioneCasiParticolariQuadroC: false,
  AutocertificazioneOneri: false,
  AutocertificazioneF6: false,
  AutocertificazioneGenerica: false,

  GruppoFascicoloContribuente: false,
  InformativaPrivacy: false,
  Scelta582x1000: false,
  DelegaUnica: false, // DelegaPrecompilatoCU AnnoImpostaPiuDue
  DocumentiDaConsegnare: false,

  GruppoStampeVarie: false,
  LetteraNovita: false,
  Barra2Provvisorio: false,

  FronteRetro: true,
  RistampaLeStampate: false,
  GuidaLettura: false,
  NrCopie: 1,
  ArchiviaInZip: false,
  SalvaPreferenze: true,

  // ModelliCompilati: false,
  // IsStampaUfficiale: false,
  // ImpostazioneStampa: 2,
};

class ModaleStampa2 extends Component {
  state = {
    ...FORM_INITIAL_STATE,
    stampaAbilitata: true,
    isLoadingInternal: false,
    delegatoCentrale: false,
    currentTab: 0,
  }

  componentDidMount() {
    const { ufficioSelezionato, annoSelezionato } = this.props;
    soscaf(ufficioSelezionato.CodiceUfficio, annoSelezionato)
      .then(({ Titolo, CodiceFiscaleIncaricato }) => this.setState({
        delegatoCentrale: Titolo === '003' && CodiceFiscaleIncaricato === 'DGNGLG63M09G888C',
      }));
  }

  componentWillReceiveProps(nextProps) {
    const { ufficioSelezionato, annoSelezionato, stampaProva } = this.props;

    if (annoSelezionato !== nextProps.annoSelezionato || ufficioSelezionato.CodiceUfficio !== nextProps.ufficioSelezionato.CodiceUfficio) {
      soscaf(nextProps.ufficioSelezionato.CodiceUfficio, nextProps.annoSelezionato)
        .then(({ Titolo, CodiceFiscaleIncaricato }) => this.setState(({ StampaDichiarazione }) => ({
          delegatoCentrale: Titolo === '003' && CodiceFiscaleIncaricato === 'DGNGLG63M09G888C',
          StampaDichiarazione: StampaDichiarazione && (stampaProva || !(Titolo === '003' && CodiceFiscaleIncaricato === 'DGNGLG63M09G888C')),
        })));
    }
  }

  componentDidUpdate(propsPrecedenti, statePrecedente) {
    const {
      showModal, userId, annoSelezionato,
    } = this.props;
    const {
      StampaDichiarazione, DelegaPrecompilatoCU,
    } = this.state;
    // const { delegatoCentrale } = this.state;

    if (showModal == true && propsPrecedenti.showModal == false) {
      this.setState({
        isLoadingInternal: true,
      });
      preferenzeStampa(userId, annoSelezionato)
        .then((res) => {
          if (res) {
            this.setState({
              ...res,
              isLoadingInternal: false,
              StampaDichiarazione: res.StampaDichiarazione,
              PromemoriaConguagli: res.PromemoriaConguagli,
              DelegaPrecompilatoCU: res.DelegaPrecompilatoCU,
              StampaF24: res.StampaF24,
              RichiestaAccredito: res.RichiestaAccredito,
              CalcoloBonusIRPEF: res.CalcoloBonusIRPEF,
              Fatture: res.Fatture,
              AutocertificazioneFamiliari: res.AutocertificazioneFamiliari,
              InformativaPrivacy: res.InformativaPrivacy,
              Scelta582x1000: res.Scelta582x1000,
              Barra2Provvisorio: res.Barra2Provvisorio,
            });
          } else {
            this.setState({ ...FORM_INITIAL_STATE, isLoadingInternal: false });
          }
        });
    } else if (StampaDichiarazione && !statePrecedente.StampaDichiarazione && !DelegaPrecompilatoCU) {
      this.setState({
        StampaDichiarazione: true,
        DelegaPrecompilatoCU: true,
      });
    }
  }

  copieKeyDown = (evt) => {
    const { NrCopie } = this.state;
    let copie = NrCopie;
    if (evt.keyCode == '38') {
      copie += 1;
    } else if (evt.keyCode == '40') {
      if (copie > 0) {
        copie -= 1;
      }
    }
    this.setState({ NrCopie: copie });
  }

  annulla = () => {
    const { onAnnulla } = this.props;
    this.setState(FORM_INITIAL_STATE, () => onAnnulla && onAnnulla());
  }

  updateForm = (data) => {
    this.setState(data, () => {
      this.aggiornaStampaAbilitata();
    });
  }

  calcoloPagineDaStampare = (totaleSelezionati, stato) => {
    const {
      StampaDichiarazione,
      DelegaPrecompilatoCU,
      PromemoriaConguagli,
      StampaF24,
      RichiestaAccredito,
      CalcoloBonusIRPEF,
      Fatture,
      AutocertificazioneFamiliari,
      AutocertificazioneC4,
      AutocertificazioneCasiParticolariQuadroC,
      AutocertificazioneOneri,
      AutocertificazioneF6,
      AutocertificazioneGenerica,
      InformativaPrivacy,
      Scelta582x1000,
      DelegaUnica,
      DocumentiDaConsegnare,
      LetteraNovita,
      Barra2Provvisorio,
      NrCopie,
    } = stato;

    // vedere quali multicopia
    let count1 = (StampaDichiarazione ? 35 * NrCopie : 0)
      + (DelegaPrecompilatoCU ? 1 : 0)
      + (PromemoriaConguagli ? 1 : 0)
      + (StampaF24 ? 1 : 0)
      + (RichiestaAccredito ? 1 : 0)
      + (CalcoloBonusIRPEF ? 1 : 0)
      + (Fatture ? 1 : 0)
      + (AutocertificazioneFamiliari ? 1 * NrCopie : 0)
      + (AutocertificazioneC4 ? 1 * NrCopie : 0)
      + (AutocertificazioneCasiParticolariQuadroC ? 1 * NrCopie : 0)
      + (AutocertificazioneOneri ? 1 * NrCopie : 0)
      + (AutocertificazioneF6 ? 1 * NrCopie : 0)
      + (AutocertificazioneGenerica ? 1 * NrCopie : 0)
      + (InformativaPrivacy ? 4 : 0)
      + (Scelta582x1000 ? 2 : 0)
      + (DelegaUnica ? 1 : 0)
      + (DocumentiDaConsegnare ? 3 : 0)
      + (LetteraNovita ? 1 : 0)
      + (Barra2Provvisorio ? 1 : 0);
    count1 *= totaleSelezionati;
    return count1;
  }

  stampa = () => {
    const { NrCopie, RistampaLeStampate, StampaDichiarazione } = this.state;
    const {
      nrDichiarazioniSelezionate, nrDichiarazioniSelezionateStampate, onStampa, totaleSelezionati,
    } = this.props;

    const maxPagineStampabili = window.config.stampa730SogliaPagineBlocco;

    const nPagineDaStampare = this.calcoloPagineDaStampare(totaleSelezionati, this.state);

    const avvisaOperazioneLunga = nPagineDaStampare > window.config.stampa730SogliaPagineAvviso;

    if (RistampaLeStampate == false && StampaDichiarazione == true && nrDichiarazioniSelezionateStampate === nrDichiarazioniSelezionate) {
      Confirm('Dichiarazioni non stampabili', 'Sono state scelte tutte dichiarazioni stampate senza l\'opzione Ristampa le già stampate.', 'error').then((x) => { });
    } else if (nPagineDaStampare > maxPagineStampabili) {
      Confirm('Dichiarazioni non stampabili', 'Le dichiarazioni scelte con le opzioni selezionate superano il limite massimo di pagine stampabili. Selezionare meno dichiarazioni o impostare un minor numero di copie.', 'error').then((x) => { });
    } else if (NrCopie > 5) {
      Confirm('Dichiarazioni non stampabili', 'Non è possibile stampare più di 5 copie. Impostare il campo "Numero Copie" ad un valore pari a 5 o inferiore', 'error').then((x) => { });
    } else {
      onStampa && onStampa(this.state, avvisaOperazioneLunga);
    }
  }

  setCheckBoxState = (propName) => {
    this.setState({
      [propName]: !this.state[propName],
    }, () => this.aggiornaStampaAbilitata());
  }

  aggiornaStampaAbilitata = () => {
    const {
      ufficioSelezionato,
    } = this.props;
    const {
      StampaDichiarazione,
      PromemoriaConguagli,
      DelegaPrecompilatoCU,
      StampaF24,
      RichiestaAccredito,
      CalcoloBonusIRPEF,
      Fatture,
      AutocertificazioneFamiliari,
      AutocertificazioneC4,
      AutocertificazioneCasiParticolariQuadroC,
      AutocertificazioneOneri,
      AutocertificazioneF6,
      AutocertificazioneGenerica,
      InformativaPrivacy,
      Scelta582x1000,
      DelegaUnica,
      DocumentiDaConsegnare,
      LetteraNovita,
      Barra2Provvisorio,
      NrCopie,
      // delegatoCentrale,
    } = this.state;

    const stAbilitata = (
      StampaDichiarazione
      || PromemoriaConguagli
      || DelegaPrecompilatoCU
      || StampaF24
      || RichiestaAccredito
      || CalcoloBonusIRPEF
      || Fatture
      || AutocertificazioneFamiliari
      || AutocertificazioneC4
      || AutocertificazioneCasiParticolariQuadroC
      || AutocertificazioneOneri
      || AutocertificazioneF6
      || AutocertificazioneGenerica
      || InformativaPrivacy
      || Scelta582x1000
      || DelegaUnica
      || DocumentiDaConsegnare
      || LetteraNovita
      || Barra2Provvisorio
    ) && NrCopie && NrCopie > 0;
    this.setState({ stampaAbilitata: stAbilitata });

    if (!StampaDichiarazione
      || !PromemoriaConguagli
      || !DelegaPrecompilatoCU
      || !StampaF24
      || !RichiestaAccredito
      || !CalcoloBonusIRPEF
      || !Fatture) {
      this.setState({ Gruppo730: false });
    }

    if (!AutocertificazioneFamiliari
      || !AutocertificazioneC4
      || !AutocertificazioneCasiParticolariQuadroC
      || !AutocertificazioneOneri
      || !AutocertificazioneF6
      || !AutocertificazioneGenerica
    ) {
      this.setState({ GruppoAutocertificazioni: false });
    }

    if (!InformativaPrivacy
      || !Scelta582x1000
      || !DelegaUnica
      || !DocumentiDaConsegnare
    ) {
      this.setState({ GruppoFascicoloContribuente: false });
    }

    if (!LetteraNovita
      || !Barra2Provvisorio
    ) {
      this.setState({ GruppoStampeVarie: false });
    }
  }

  clickGruppo730 = () => {
    const {
      Gruppo730,
      StampaDichiarazione,
      PromemoriaConguagli,
      DelegaPrecompilatoCU,
      StampaF24,
      RichiestaAccredito,
      CalcoloBonusIRPEF,
      Fatture,
      // delegatoCentrale,
    } = this.state;
    const { ufficioSelezionato } = this.props;
    if (Gruppo730 == false) {
      this.setState({
        Gruppo730: true,
        StampaDichiarazione: true,
        PromemoriaConguagli: true,
        DelegaPrecompilatoCU: true,
        StampaF24: true,
        RichiestaAccredito: true,
        CalcoloBonusIRPEF: true,
        Fatture: true,
      }, () => this.aggiornaStampaAbilitata());
    } else if ([Gruppo730,
      StampaDichiarazione,
      PromemoriaConguagli,
      DelegaPrecompilatoCU,
      StampaF24,
      RichiestaAccredito,
      CalcoloBonusIRPEF,
      Fatture].every(z => z)) {
      this.setState({
        Gruppo730: false,
        StampaDichiarazione: false,
        PromemoriaConguagli: false,
        DelegaPrecompilatoCU: false,
        StampaF24: false,
        RichiestaAccredito: false,
        CalcoloBonusIRPEF: false,
        Fatture: false,
      }, () => this.aggiornaStampaAbilitata());
    } else {
      this.aggiornaStampaAbilitata();
    }
  }

  clickGruppoAutocertificazioni = () => {
    const {
      GruppoAutocertificazioni,
      AutocertificazioneFamiliari,
      AutocertificazioneC4,
      AutocertificazioneCasiParticolariQuadroC,
      AutocertificazioneOneri,
      AutocertificazioneF6,
      AutocertificazioneGenerica,
      // delegatoCentrale,
    } = this.state;
    if (GruppoAutocertificazioni == false) {
      this.setState({
        GruppoAutocertificazioni: true,
        AutocertificazioneFamiliari: true,
        AutocertificazioneC4: true,
        AutocertificazioneCasiParticolariQuadroC: true,
        AutocertificazioneOneri: true,
        AutocertificazioneF6: true,
        AutocertificazioneGenerica: true,
      }, () => this.aggiornaStampaAbilitata());
    } else if ([GruppoAutocertificazioni,
      AutocertificazioneFamiliari,
      AutocertificazioneC4,
      AutocertificazioneCasiParticolariQuadroC,
      AutocertificazioneOneri,
      AutocertificazioneF6,
      AutocertificazioneGenerica].every(z => z)) {
      this.setState({
        GruppoAutocertificazioni: false,
        AutocertificazioneFamiliari: false,
        AutocertificazioneC4: false,
        AutocertificazioneCasiParticolariQuadroC: false,
        AutocertificazioneOneri: false,
        AutocertificazioneF6: false,
        AutocertificazioneGenerica: false,
      }, () => this.aggiornaStampaAbilitata());
    } else {
      this.aggiornaStampaAbilitata();
    }
  }

  clickGruppoFascicoloContribuente = () => {
    const {
      GruppoFascicoloContribuente, InformativaPrivacy, Scelta582x1000, DocumentiDaConsegnare, DelegaUnica, // delegatoCentrale,
    } = this.state;

    if (GruppoFascicoloContribuente == false) {
      this.setState({
        GruppoFascicoloContribuente: true,
        InformativaPrivacy: true,
        Scelta582x1000: true,
        DocumentiDaConsegnare: true,
        DelegaUnica: true,
      }, () => this.aggiornaStampaAbilitata());
    } else if ([GruppoFascicoloContribuente, InformativaPrivacy, Scelta582x1000, DocumentiDaConsegnare, DelegaUnica].every(z => z)) {
      this.setState({
        GruppoFascicoloContribuente: false,
        InformativaPrivacy: false,
        Scelta582x1000: false,
        DocumentiDaConsegnare: false,
        DelegaUnica: false,
      }, () => this.aggiornaStampaAbilitata());
    } else {
      this.aggiornaStampaAbilitata();
    }
  }

  clickGruppoStampeVarie = () => {
    const {
      GruppoStampeVarie, LetteraNovita, Barra2Provvisorio, // delegatoCentrale,
    } = this.state;
    if (GruppoStampeVarie == false) {
      this.setState({
        GruppoStampeVarie: true,
        LetteraNovita: true,
        Barra2Provvisorio: true,
      }, () => this.aggiornaStampaAbilitata());
    } else if ([GruppoStampeVarie, LetteraNovita, Barra2Provvisorio].every(z => z)) {
      this.setState({
        GruppoStampeVarie: false,
        LetteraNovita: false,
        Barra2Provvisorio: false,
      }, () => this.aggiornaStampaAbilitata());
    } else {
      this.aggiornaStampaAbilitata();
    }
  }

  render() {
    const {
      showModal, stampaProva, messaggioErrore, isLoadingModale, annoSelezionato, selezionatiDaAnnoPrecedente, totaleSelezionati, ufficioSelezionato,
    } = this.props;
    const {
      Gruppo730,
      StampaDichiarazione,
      DelegaPrecompilatoCU,
      PromemoriaConguagli,
      StampaF24,
      RichiestaAccredito,
      CalcoloBonusIRPEF,
      Fatture,

      GruppoAutocertificazioni,
      AutocertificazioneFamiliari,
      AutocertificazioneC4,
      AutocertificazioneCasiParticolariQuadroC,
      AutocertificazioneOneri,
      AutocertificazioneF6,
      AutocertificazioneGenerica,

      GruppoFascicoloContribuente,
      InformativaPrivacy,
      Scelta582x1000,
      DelegaUnica,
      DocumentiDaConsegnare,

      GruppoStampeVarie,
      LetteraNovita,
      Barra2Provvisorio,

      FronteRetro,
      RistampaLeStampate,
      GuidaLettura,
      ArchiviaInZip,
      SalvaPreferenze,
      isLoadingInternal,
      stampaAbilitata,
      // delegatoCentrale,
      currentTab,
    } = this.state;

    const annoImpostaPiuUno = parseInt(annoSelezionato, 10);
    const annoImpostaPiuDue = parseInt(annoSelezionato, 10) + 1;

    const mostraAlertAnnoPrecedente = selezionatiDaAnnoPrecedente
      && (StampaDichiarazione
        || PromemoriaConguagli
        || DelegaPrecompilatoCU
        || StampaF24
        || RichiestaAccredito
        || CalcoloBonusIRPEF
        || Fatture
        || AutocertificazioneFamiliari
        || AutocertificazioneC4
        || AutocertificazioneCasiParticolariQuadroC
        || AutocertificazioneOneri
        || AutocertificazioneF6
        || AutocertificazioneGenerica
        || Barra2Provvisorio
        || LetteraNovita
      );

    // const stimaPagineDaStampare = this.calcoloPagineDaStampare(totaleSelezionati, this.state);

    const linkAssistenteStampa = `${window.config.urlAssistente}/permalink/contenuto?aliasArea=730&codiceUfficio=${ufficioSelezionato.CodiceUfficio}&permalink=stampa`;
    const linkAssistenteFea = `${window.config.urlAssistente}/permalink/dossier?aliasArea=INF&codiceUfficio=${ufficioSelezionato.CodiceUfficio}&permalink=scoprifea`;

    return (
      <Modal show={showModal} onClose={this.annulla} loading={isLoadingInternal || isLoadingModale} className="printerDialog" style={{ width: '1000px' }}>
        <Modal.Header><h4>Stampa</h4>

        </Modal.Header>
        <Modal.Body>
          <Form stato={this.state} onChange={this.updateForm} ref={r => this.form = r}>

            <Tabs
              onSelect={i => this.setState({ currentTab: i })}
              action={(
                <div style={{
                  position: 'relative',
                  width: '550px',
                  float: 'right',
                  textAlign: 'right',
                }}
                >
                  <a href={linkAssistenteStampa} target="_blank" style={{ lineHeight: '40px' }}>informazioni sulla stampa &nbsp;&nbsp;</a>
                  <AssistenteButton
                    permalink="stampa"
                    area="730"
                    codiceUfficio={ufficioSelezionato.CodiceUfficio}
                  />
                </div>
              )}
            >
              <Tabs.Tab
                title={(
                  <span>
                    Documenti da stampare
                  </span>
                )}
              >
                <Panel info title="Alert">Utilizza la nuova funzionalità di <a href={linkAssistenteFea} target="_blank">Firma Elettronica Avanzata</a> per firmare i documenti velocemente <strong>riducendo al minimo ciò che dovrai stampare</strong></Panel>
                {mostraAlertAnnoPrecedente && <Panel alert title="Alert">Non tutte le stampe sono supportate per le dichiarazioni con stato &quot;Anno precedente&quot;<br /></Panel>}
                <Grid fluid>
                  <Grid.Row className="mb-8">
                    <Grid.Col md="4">

                      {/* <!-- gruppo 730 --> */}

                      <div style={{ height: 210 }}>

                        <h5 style={{
                          marginTop: '24px',
                          marginBottom: '6px',
                        }}
                        >
                          <label>
                            <Checkbox
                              checked={Gruppo730}
                              onChange={() => this.clickGruppo730()}
                            />Documenti 730
                          </label>
                        </h5>

                        <label>
                          <Checkbox
                            checked={StampaDichiarazione}
                            onChange={() => this.setCheckBoxState('StampaDichiarazione')}
                          />

                          Stampa mod. 730/{annoSelezionato} {stampaProva ? ' di prova' : ''}

                        </label><br />

                        <label>
                          <Checkbox
                            checked={PromemoriaConguagli}
                            onChange={() => this.setCheckBoxState('PromemoriaConguagli')}
                          />Promemoria conguagli
                        </label><br />

                        <label>
                          <Checkbox
                            checked={DelegaPrecompilatoCU}
                            onChange={() => this.setCheckBoxState('DelegaPrecompilatoCU')}
                          />Delega Precompilato - CU {annoImpostaPiuDue}
                        </label><br />
                        <label>
                          <Checkbox
                            checked={StampaF24}
                            onChange={() => this.setCheckBoxState('StampaF24')}
                          />
                          Stampa F24
                        </label><br />

                        <label>
                          <Checkbox
                            checked={RichiestaAccredito}
                            onChange={() => this.setCheckBoxState('RichiestaAccredito')}
                          />
                          Richiesta accredito
                        </label><br />

                        <label>
                          <Checkbox
                            checked={CalcoloBonusIRPEF}
                            onChange={() => this.setCheckBoxState('CalcoloBonusIRPEF')}
                          />
                          Calcolo bonus IRPEF
                        </label><br />

                        <label>
                          <Checkbox
                            checked={Fatture}
                            onChange={() => this.setCheckBoxState('Fatture')}
                          />
                          Fatture
                        </label>
                      </div>


                      <div style={{ height: 56 }}>
                        <h5 style={{
                          marginTop: '24px',
                          marginBottom: '8px',
                        }}
                        >
                          <label>
                            <Checkbox
                              checked={GruppoStampeVarie}
                              onChange={() => this.clickGruppoStampeVarie()}
                            />Stampe Varie
                          </label>
                        </h5>

                        <label>
                          <Checkbox
                            checked={LetteraNovita}
                            onChange={() => this.setCheckBoxState('LetteraNovita')}
                          />Lettera novità 730/2021
                        </label><br />
                        <label>
                          <Checkbox
                            checked={Barra2Provvisorio}
                            onChange={() => this.setCheckBoxState('Barra2Provvisorio')}
                          />730/2 Provvisorio
                        </label>
                      </div>
                    </Grid.Col>

                    <Grid.Col md="4">

                      {/* <!-- gruppo Autocertificazioni --> */}

                      <div style={{ height: 210 }}>

                        <h5 style={{
                          marginTop: '24px',
                          marginBottom: '8px',
                        }}
                        >
                          <label>
                            <Checkbox
                              checked={GruppoAutocertificazioni}
                              onChange={() => this.clickGruppoAutocertificazioni()}
                            />Autocertificazioni
                          </label>
                        </h5>

                        <label>
                          <Checkbox
                            checked={AutocertificazioneFamiliari}
                            onChange={() => this.setCheckBoxState('AutocertificazioneFamiliari')}
                          />Autocertificazione familiari a carico
                        </label>

                        <label>
                          <Checkbox
                            checked={AutocertificazioneC4}
                            onChange={() => this.setCheckBoxState('AutocertificazioneC4')}
                          />Autocertificazione C4
                        </label>

                        <label>
                          <Checkbox
                            checked={AutocertificazioneCasiParticolariQuadroC}
                            onChange={() => this.setCheckBoxState('AutocertificazioneCasiParticolariQuadroC')}
                          />Autocert. agevolazione rientro in Italia
                        </label>

                        <label>
                          <Checkbox
                            checked={AutocertificazioneOneri}
                            onChange={() => this.setCheckBoxState('AutocertificazioneOneri')}
                          />Autocertificazioni quadro E, F e G
                        </label>

                        <label>
                          <Checkbox
                            checked={AutocertificazioneF6}
                            onChange={() => this.setCheckBoxState('AutocertificazioneF6')}
                          />Autocertificazione F6
                        </label>

                        <label>
                          <Checkbox
                            checked={AutocertificazioneGenerica}
                            onChange={() => this.setCheckBoxState('AutocertificazioneGenerica')}
                          />Autocertificazione generica
                        </label>
                      </div>
                    </Grid.Col>

                    {/* Fascicolo Contribuente */}

                    <Grid.Col md="4">


                      <div style={{ height: 56 }}>
                        <h5 style={{
                          marginTop: '24px',
                          marginBottom: '8px',
                        }}
                        >
                          <label>
                            <Checkbox
                              checked={GruppoFascicoloContribuente}
                              onChange={() => this.clickGruppoFascicoloContribuente()}
                            />Fascicolo contribuente
                          </label>
                        </h5>

                        <label>
                          <Checkbox
                            checked={InformativaPrivacy}
                            onChange={() => this.setCheckBoxState('InformativaPrivacy')}
                          />Informativa privacy
                        </label><br />

                        <label>
                          <Checkbox
                            checked={Scelta582x1000}
                            onChange={() => this.setCheckBoxState('Scelta582x1000')}
                          />Scelta 5-8-2 x 1000
                        </label><br />

                        <label style={{ color: '#ccc' }}>
                          <Checkbox
                            checked={false}
                            disabled
                            onChange={() => this.setCheckBoxState('DelegaUnica')}
                          />Delega Precompilato - CU {annoImpostaPiuUno}
                          <InfoTooltip>
                          La stampa non è selezionabile poiché la campagna 730 2020 è conclusa. <br />
                            Per stampare il mandato con l'autorizzazione relativa alla sola CU 2020, accedi all'applicazione Richieste Enti
                          </InfoTooltip>
                        </label>
                        <br />

                        <label>
                          <Checkbox
                            checked={DocumentiDaConsegnare}
                            onChange={() => this.setCheckBoxState('DocumentiDaConsegnare')}
                          />Elenco documenti consegnati
                        </label>
                      </div>
                    </Grid.Col>
                  </Grid.Row>
                </Grid>
              </Tabs.Tab>


              <Tabs.Tab title="Opzioni di stampa">
                <Grid fluid>
                  <Grid.Row>
                    <Grid.Col md="12">

                      <Grid fluid>
                        <Grid.Row>

                          <Grid.Col md="3">
                            <div style={{
                              paddingTop: '16px',
                            }}
                            >
                              <Input
                                title="Numero copie"
                                name="NrCopie"
                                onKeyDown={this.copieKeyDown}
                                validations={[{
                                  rule: 'Pattern',
                                  pattern: new RegExp('^[0-9]*$'),
                                  message: 'Indicare il numero di copie da stampare',
                                },
                                {
                                  rule: 'required',
                                  message: 'Indicare il numero di copie da stampare',
                                }]}
                                className="w-120"
                              /><br />
                              <label style={{
                                marginBottom: '40px',
                              }}
                              >
                                <Checkbox
                                  checked={SalvaPreferenze}
                                  onChange={() => this.setCheckBoxState('SalvaPreferenze')}
                                /> Ricorda le opzioni
                              </label>
                            </div>
                          </Grid.Col>

                          <Grid.Col md="4">
                            <div style={{
                              paddingTop: '40px',
                            }}
                            >
                              <label>
                                <Checkbox
                                  checked={FronteRetro}
                                  onChange={() => this.setCheckBoxState('FronteRetro')}
                                  switch
                                /> Stampa fronte/retro
                              </label><br />
                              <label>
                                <Checkbox
                                  checked={RistampaLeStampate}
                                  onChange={() => this.setCheckBoxState('RistampaLeStampate')}
                                  switch
                                /> Ristampa le già stampate
                              </label>
                            </div>
                          </Grid.Col>

                          <Grid.Col md="5">
                            <div style={{
                              paddingTop: '40px',
                            }}
                            >
                              <label>
                                <Checkbox
                                  checked={ArchiviaInZip}
                                  onChange={() => this.setCheckBoxState('ArchiviaInZip')}
                                  switch
                                /> Creazione pdf separati per ogni contribuente
                              </label>
                              <label>
                                <Checkbox
                                  checked={GuidaLettura}
                                  onChange={() => this.setCheckBoxState('GuidaLettura')}
                                  switch
                                /> Stampa guida lettura (solo prima copia)
                              </label>
                            </div>
                          </Grid.Col>
                        </Grid.Row>

                      </Grid>

                    </Grid.Col>
                  </Grid.Row>
                </Grid>
              </Tabs.Tab>

            </Tabs>

            {messaggioErrore && <Panel error>{messaggioErrore}</Panel>}
          </Form>

        </Modal.Body>
        <Modal.Footer>
          {currentTab == 0 && <Button flat onClick={this.annulla}>Annulla</Button>}
          {currentTab == 0 && <Button flat primary onClick={this.stampa} disabled={!stampaAbilitata}>Stampa</Button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleStampa2.propTypes = {
  isLoadingModale: PropTypes.bool,
  messaggioErrore: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  nrDichiarazioniSelezionate: PropTypes.number.isRequired, // se seleziona tutti il numero di quelle visibili in dashboard
  nrDichiarazioniSelezionateStampate: PropTypes.number.isRequired,
  onAnnulla: PropTypes.func.isRequired,
  onStampa: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  stampaProva: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  annoSelezionato: PropTypes.number.isRequired,
  selezionatiDaAnnoPrecedente: PropTypes.bool.isRequired,
  totaleSelezionati: PropTypes.number.isRequired, // se seleziona tutti il numero complessivo
  ufficioSelezionato: PropTypes.object.isRequired,
};

ModaleStampa2.defaultProps = {
  isLoadingModale: false,
  messaggioErrore: '',
};

export default ModaleStampa2;
